import React from "react";
import PropTypes from "prop-types";

import Close from "../../../Icons/Close";
import Index from "./Index";

const propTypes = {
  /**
   * The function to be called when the cancel button is clicked.
   */
  onCancel: PropTypes.func.isRequired
};

const defaultProps = {
  onCancel: () => {}
};

const WithCancel = ({ onCancel, children, ...props }) => {
  return (
    <Index
      action={{
        icon: <Close />,
        onClick: onCancel,
        name: "Cancel"
      }}
      {...props}
    >
      {children}
    </Index>
  );
};

WithCancel.propTypes = propTypes;
WithCancel.defaultProps = defaultProps;

export default WithCancel;
